var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17697_3481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8245 5.17531L10.4824 4.69287L5.1754 5.17531L4.69287 9.99991L5.17531 14.8245L9.99991 15.4276L14.8245 14.8245L15.307 9.87937L14.8245 5.17531Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.15458 12.6605C6.79397 12.4168 6.54427 12.0611 6.40796 11.5906L7.24506 11.2457C7.32105 11.5352 7.45369 11.7595 7.64308 11.9187C7.83127 12.0779 8.06043 12.1563 8.32819 12.1563C8.602 12.1563 8.83722 12.0731 9.03375 11.9066C9.23028 11.7401 9.32928 11.5278 9.32928 11.271C9.32928 11.0081 9.22552 10.7933 9.01808 10.6269C8.81063 10.4606 8.55012 10.3772 8.23891 10.3772H7.75528V9.54866H8.18941C8.45717 9.54866 8.68276 9.47634 8.86609 9.3316C9.04943 9.18685 9.14109 8.98904 9.14109 8.73695C9.14109 8.51265 9.05905 8.33408 8.89506 8.20025C8.73107 8.06641 8.52353 7.99885 8.27145 7.99885C8.02542 7.99885 7.82998 8.06403 7.68524 8.19548C7.5405 8.32693 7.43554 8.48854 7.36927 8.67911L6.54069 8.33417C6.65042 8.02296 6.8519 7.74796 7.14734 7.51036C7.44288 7.27276 7.82036 7.15332 8.27869 7.15332C8.61758 7.15332 8.92274 7.2185 9.19298 7.34995C9.46312 7.4814 9.67542 7.66354 9.82859 7.89509C9.98177 8.12783 10.0578 8.38844 10.0578 8.67783C10.0578 8.97336 9.98663 9.22297 9.84427 9.42803C9.70191 9.63309 9.52701 9.78984 9.31957 9.89965V9.94906C9.59338 10.0636 9.81649 10.2385 9.99258 10.4738C10.1675 10.709 10.2555 10.99 10.2555 11.3181C10.2555 11.6462 10.1723 11.9392 10.0058 12.1962C9.83932 12.4531 9.60896 12.6557 9.31709 12.8028C9.02403 12.95 8.69477 13.0248 8.32929 13.0248C7.90598 13.0259 7.5152 12.9041 7.15458 12.6605Z",
    fill: "#1A73E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2918 8.50674L11.3775 9.17132L10.918 8.4742L12.5668 7.28491H13.1988V12.8946H12.2918V8.50674Z",
    fill: "#1A73E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8245 19.1666L19.1666 14.8245L16.9955 13.8596L14.8245 14.8245L13.8596 16.9955L14.8245 19.1666Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.21045 16.9955L5.17533 19.1665H14.8244V14.8245H5.17533L4.21045 16.9955Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.28058 0.833252C1.48097 0.833252 0.833252 1.48097 0.833252 2.28058V14.8244L3.00429 15.7893L5.17532 14.8244V5.17532H14.8244L15.7893 3.00429L14.8245 0.833252H2.28058Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.833252 14.8245V17.7192C0.833252 18.5189 1.48097 19.1665 2.28058 19.1665H5.17532V14.8245H0.833252Z",
    fill: "#188038"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8245 5.17533V14.8244H19.1665V5.17533L16.9955 4.21045L14.8245 5.17533Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1665 5.17532V2.28058C19.1665 1.48088 18.5188 0.833252 17.7192 0.833252H14.8245V5.17532H19.1665Z",
    fill: "#1967D2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17697_3481"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleCalendar);
export default __webpack_public_path__ + "static/media/google-calendar.56f722f99c6a90cd7640bb2c4fcf2ea1.svg";
export { ForwardRef as ReactComponent };